import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Date",
  "Meeting Title",
  "Not Attennd / Attend",
  "Conduct Meeting",
  "Actions",
];
const returnClassname = (isApproved) => {
  return isApproved
    ? "badge bg-success  text-white"
    : "badge bg-danger  text-white";
};
const ScrumTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-scrum-meetings/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {/* <td>{getId(item?.dcNumber)}</td> */}
                <td>{item?.date || "N/A"}</td>
                <td>{item?.title || "N/A"}</td>

                {
                  item.conductMetting === "Demo" ? <td>
                   <span className="ms-5">--</span>
                  
                  </td> : <td>
                    <span className="ms-5">
                      {item?.lineItems?.filter((item) => item?.absent)?.length}
                    </span>{" "}
                    / <span>{item?.lineItems?.length - item?.lineItems?.filter((item) => item?.absent)?.length}</span>
                  </td>
                }
                <td>{item?.conductMetting || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ScrumTable;
